import { ReactFlowInstance } from "reactflow"
import { SupabaseConnector } from "../database/SupabaseConnector"
import { SetNodesState } from "../types/UITypes"
import PdfToImg from "pdftoimg-js/lib/browser"
import { fileToBase64 } from "./common"
import { parseAutogenMatrices } from "./autogenMatrices"
import { MutableRefObject } from "react"
import { parseAutogenSheets } from "./autogenSheets"
import { arrangeAutogenSheets } from "./arrangeAutogenSheets"
import { DatabaseLogic, DatabaseSheet } from "../types/SupabaseTypesHelper"

export async function autogenerateCanvas(
  autogeneratePrompt: string,
  filesToUpload: File[],
  canvasId: string,
  setNodes: SetNodesState,
  supabaseConnector: SupabaseConnector,
  reactFlowRef: MutableRefObject<ReactFlowInstance | null>
) {
  let imageBase64: string | undefined
  const file = filesToUpload?.length ? filesToUpload[0] : undefined

  if (file) {
    if (file.type === "application/pdf") {
      const pdfBuffer = await file.arrayBuffer()
      const images = await PdfToImg(pdfBuffer)
      imageBase64 = images ? images[0] : undefined
    } else {
      imageBase64 = (await fileToBase64(file)) as string
    }
  }

  const importedApiJSON = await supabaseConnector.autogenerateCanvas(
    autogeneratePrompt,
    imageBase64
  )

  if (importedApiJSON.matrices) {
    const matrices = await parseAutogenMatrices(
      importedApiJSON,
      canvasId,
      reactFlowRef.current!
    )
    setNodes((nodes) => [...nodes, ...matrices])
  }

  if (importedApiJSON.sheets) {
    const {
      importedSheets,
      importedLogics,
      importedEdges,
      sheetsData,
      cellsData,
      edgesData,
      logicsData,
      columnLabelsData,
    } = await parseAutogenSheets(
      importedApiJSON,
      canvasId,
      reactFlowRef.current!
    )

    let autogenEntities = {
      importedSheets,
      importedEdges,
      importedLogics,
    }

    let arrangedAutogenEntities

    try {
      arrangedAutogenEntities = arrangeAutogenSheets(
        autogenEntities,
        reactFlowRef.current!
      )
    } catch (e) {
      console.error(e)
    }

    const uiEntities = arrangedAutogenEntities || autogenEntities

    const uiSheetsById = uiEntities.importedSheets.reduce((acc, sheet) => {
      acc[sheet.data.id] = sheet
      return acc
    }, {} as Record<string, any>)

    const uiLogicsById = uiEntities.importedLogics.reduce((acc, logic) => {
      acc[logic.data.id] = logic
      return acc
    }, {} as Record<string, any>)

    return {
      uiEntities: arrangedAutogenEntities || autogenEntities,
      dbEntities: {
        sheetsData: sheetsData.map((sheet: DatabaseSheet) => ({
          ...sheet,
          position_x: uiSheetsById[sheet.id]?.position.x || 0,
          position_y: uiSheetsById[sheet.id]?.position.y || 0,
        })),
        cellsData,
        edgesData,
        logicsData: logicsData.map((logic: DatabaseLogic) => ({
          ...logic,
          position_x: uiLogicsById[logic.id]?.position.x || 0,
          position_y: uiLogicsById[logic.id]?.position.y || 0,
        })),
        columnLabelsData,
      },
    }
  }
}
